import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const setUpcomingCheckoutSplitsOrder = {
  name: "setUpcomingCheckoutSplitsOrder" as const,
  input: z.array(zExt.objectId()),
  output: z.null(),
};
